import * as React from 'react';
import customIconWrapper from './custom-icons';

const MistralIcon = customIconWrapper(<>
	<rect x="31" y="31" width="20" height="20" fill="#FFAF01" />
	<rect x="111" y="31" width="20" height="20" fill="#FFAF01" />
	<rect x="71" y="91" width="20" height="20" fill="#E61300" />
	<rect x="31" y="91" width="20" height="20" fill="#E61300" />
	<rect x="111" y="91" width="20" height="20" fill="#E61300" />
	<rect x="31" y="51" width="40" height="20" fill="#FF8204" />
	<rect x="11" y="111" width="60" height="20" fill="#C4001D" />
	<rect x="91" y="111" width="60" height="20" fill="#C4001D" />
	<rect x="31" y="71" width="100" height="20" fill="#FA500F" />
	<rect x="91" y="51" width="40" height="20" fill="#FF8204" /></>, { viewBox: '11 11 140 140' });

export default MistralIcon;
